import { reducerConstants } from "../../../constants/reducer-constant";
import { INITIAL_STATE as eChallanReducerInitialState, HANDLERS as eChallanReducerHandler } from "../../../components/desktop/e-challan/reducers";
import { INITIAL_STATE as myChallansReducerInitialState, HANDLERS as myChallansReducerHandler } from "../../../components/desktop/my-challans/reducer";

export default {
    [reducerConstants.E_CHALLAN]: { state: eChallanReducerInitialState, handler: eChallanReducerHandler},
    [reducerConstants.MY_CHALLANS]: { state: myChallansReducerInitialState, handler: myChallansReducerHandler}
};
